var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c(
              "el-form",
              {
                ref: "basicForm",
                staticStyle: { display: "flex" },
                attrs: {
                  "label-position": "right",
                  "label-width": "100px",
                  disabled: _vm.viewStatus
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    style: _vm.$selectByLang("", "width:320px;")
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.JobNo") } },
                      [
                        _c("el-input", {
                          attrs: { no: "1", disabled: true },
                          model: {
                            value: _vm.job.jobNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "jobNo", $$v)
                            },
                            expression: "job.jobNo"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.isZY
                      ? [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AllowSaleProduct"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_AllowSaleProduct,
                                  filterable: "",
                                  no: "allowSaleProduct",
                                  clearable: "",
                                  "data-filter-function": function(p) {
                                    if (!p.statusEnabled) {
                                      return false
                                    }
                                    return _vm.isFba
                                      ? p.fbaAir
                                      : p.airExportEnabled
                                  },
                                  "default-value": _vm.job.saleProductCode || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.saleProductCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.FullOrInside"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_FullOrInside$FULL_OR_INSIDE,
                                  no: "fullOrInside",
                                  clearable: "",
                                  "default-value": _vm.job.fullOrInside || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.fullOrInside = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Mbl2") } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-right": "2px" },
                            attrs: { no: "122" },
                            on: { change: _vm.expressChangeHandler },
                            model: {
                              value: _vm.job.express,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "express", $$v)
                              },
                              expression: "job.express"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                        ),
                        _vm.job.express
                          ? _c("el-input", {
                              staticStyle: { width: "130px" },
                              attrs: { no: "21" },
                              on: { change: _vm.mblChange },
                              model: {
                                value: _vm.job.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mbl", $$v)
                                },
                                expression: "job.mbl"
                              }
                            })
                          : _vm._e(),
                        !_vm.job.express
                          ? _c("mawb-no-input", {
                              ref: "mawbNoInput",
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "5px"
                              },
                              attrs: { editable: _vm.isEditablemawbNoInput },
                              on: {
                                change: _vm.mblChangeHandler,
                                changeCallback: function($event) {
                                  return _vm.mblCheckHandler(true)
                                }
                              },
                              model: {
                                value: _vm.job.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mbl", $$v)
                                },
                                expression: "job.mbl"
                              }
                            })
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "margin-left": "1px",
                                  "padding-left": "10px",
                                  "padding-right": "10px"
                                },
                                attrs: {
                                  no: "2",
                                  type: "primary",
                                  disabled: !_vm.selectBtnEnable
                                },
                                on: { click: _vm.selectMBLNoHandler }
                              },
                              [_vm._v(_vm._s(_vm.selectMawbDialog.btnName))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.PlaceOfReceipt") } },
                      [
                        _c("el-input", {
                          attrs: { no: "77" },
                          model: {
                            value: _vm.job.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dispatchingPlace", $$v)
                            },
                            expression: "job.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.LoadingPort")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: { no: "3", disabled: true },
                            model: {
                              value: _vm.loading3Code,
                              callback: function($$v) {
                                _vm.loading3Code = $$v
                              },
                              expression: "loading3Code"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "4",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "default-value": _vm.job.loadingPortCode,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.loadingPortChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("el-form-item", [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestination")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: { no: "5", disabled: true },
                            model: {
                              value: _vm.destination3Code,
                              callback: function($$v) {
                                _vm.destination3Code = $$v
                              },
                              expression: "destination3Code"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "6",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "default-value": _vm.job.destinationPortCode,
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationPortCodeChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.FinalPlaceOfDelivery")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "7" },
                          on: {
                            input: function(val) {
                              _vm.job.destinationPlace = val
                                ? val.toUpperCase()
                                : ""
                            }
                          },
                          model: {
                            value: _vm.job.destinationPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destinationPlace", $$v)
                            },
                            expression: "job.destinationPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "8" },
                              model: {
                                value: _vm.job.transfering,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "transfering", $$v)
                                },
                                expression: "job.transfering"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Transit2")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "9",
                                type: "primary",
                                disabled:
                                  _vm.viewStatus ||
                                  (!_vm.viewStatus && !_vm.job.transfering)
                              },
                              on: { click: _vm.setTransferingHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.EnterTransitInfo"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "10",
                                clearable: false,
                                filterable: "",
                                fields: ["chineseName"],
                                "select-type":
                                  _vm.selectTypeNames.local_cache_CargoSource,
                                "callback-method-type": "value",
                                "default-value": _vm.job.cargoSource,
                                "callback-params": { key: "cargoSource" }
                              },
                              on: { parentCallBack: _vm.cargoSouceChange }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.ServiceProduct") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "145",
                                clearable: false,
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_AirServiceProduct,
                                "callback-method-type": "value",
                                "default-value": _vm.job.serviceProduct,
                                "callback-params": { key: "serviceProduct" }
                              },
                              on: { parentCallBack: _vm.setJobSelectValue }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_AirlineProductCode")
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "airlineProductUuid",
                                filterable: "",
                                "static-options": _vm.airlineProductDownList,
                                "method-params": { active: true },
                                "tag-value": "uuid",
                                "tag-name": "name",
                                "filter-tag-names": ["name"],
                                "static-component": new _vm.AutoComplete(),
                                "callback-method-type": "value",
                                "default-value": _vm.job.airlineProductUuid,
                                "callback-params": { key: "airlineProductUuid" }
                              },
                              on: { parentCallBack: _vm.setJobSelectValue }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "11",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_CutomJobType,
                            "method-params": { type: _vm.job.lob },
                            "default-value": _vm.job.customJobType,
                            "static-options": _vm.customJobTypeList
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.customJobType = p.value
                              _vm.setJobSelectValue(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Information.AppraisalCategory")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "146",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_AppraisalCategory,
                            "default-value": _vm.job.appraisalCategory,
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.appraisalCategory = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.customJobType &&
                    _vm.secondaryCustomJobTypeList.length > 0
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") } },
                          [
                            _c("cargo-advance-select", {
                              ref: "secondaryCustomJobType",
                              attrs: {
                                no: "secondaryCustomJobType",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_CutomJobType,
                                filterable: "",
                                cache: false,
                                "default-value": _vm.job.secondaryCustomJobType,
                                "tag-name": _vm.isZh ? "name" : "englishName",
                                "static-options": _vm.secondaryCustomJobTypeList
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.job.secondaryCustomJobType = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.DestinationAgent") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "12",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "default-value": _vm.job.destinationAgent || "",
                            "tag-name": "englishName",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.pm.destinationAgentChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.job.cargoSource === "NC"
                      ? _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "blue",
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.NominatedAgent"))
                                )
                              ]
                            ),
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "13",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  designationAgent: true,
                                  active: true
                                },
                                "callback-method-type": "value",
                                "default-value": _vm.job.designationAgent || "",
                                "tag-name": "englishName",
                                "callback-params": { key: "designationAgent" },
                                disabled: !_vm.designationAgentEnabled,
                                placeholder: " "
                              },
                              on: { parentCallBack: _vm.setJobSelectValue }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.BillExchangeAgent") }
                      },
                      [
                        _c("cargo-company-select", {
                          attrs: {
                            no: "exChangeAgent",
                            disabled: !_vm.job.dischargingPortDoor,
                            "method-params": {
                              bookingAgent: true,
                              active: true
                            },
                            "default-value": _vm.job.exChangeAgent || ""
                          },
                          on: { change: _vm.onExChangeAgentChange }
                        })
                      ],
                      1
                    ),
                    _vm.bookingAgentVisible
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("SeaExport.BookingAgent") }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "14",
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  bookingAgent: true,
                                  active: true
                                },
                                "callback-method-type": "value",
                                "default-value": _vm.job.bookingAgent || "",
                                "callback-params": { key: "bookingAgent" },
                                disabled: !_vm.bookingAgentEnabled,
                                placeholder: " "
                              },
                              on: { parentCallBack: _vm.setJobSelectValue }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                      [
                        _c("el-date-picker", {
                          ref: "fileCutoff",
                          staticStyle: { width: "100%" },
                          attrs: {
                            no: "15",
                            type: "datetime",
                            clearable: "",
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            blur: function() {
                              _vm.handleBlur(
                                "fileCutoff",
                                null,
                                true,
                                false,
                                _vm.job
                              )
                            }
                          },
                          model: {
                            value: _vm.job.fileCutoff,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "fileCutoff", $$v)
                            },
                            expression: "job.fileCutoff"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.isFba
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("SeaExport.ActualDateOfDeparture")
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                no: "16",
                                type: "date",
                                clearable: "",
                                format: "yyyy-MM-dd",
                                "value-format": "yyyy-MM-dd"
                              },
                              model: {
                                value: _vm.job.atd,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "atd", $$v)
                                },
                                expression: "job.atd"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          class:
                            _vm.job.cargoEnglishNameWarning === 1
                              ? "red-border"
                              : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "17",
                            disabled: _vm.viewStatus,
                            "text-chars": 0,
                            "warning-count": 45,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                                _vm.job.cargoEnglishName,
                                function(val) {
                                  _vm.pm.cargoEnglishNameChangeHandler(val)
                                },
                                true,
                                null,
                                _vm.isUppercaseByConfig,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoEnglishName", $$v)
                            },
                            expression: "job.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: {
                          label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          class:
                            _vm.job.cargoChineseNameWarning === 1
                              ? "red-border"
                              : "",
                          staticStyle: { height: "110px" },
                          attrs: {
                            no: "49",
                            disabled: _vm.viewStatus,
                            "text-chars": 0,
                            "warning-count": 45
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                _vm.job.cargoChineseName,
                                function(val) {
                                  _vm.job.cargoChineseName = val
                                },
                                true,
                                null,
                                true,
                                {
                                  warningCount: _vm.englishNameWarningCount,
                                  maxChar: _vm.englishNameMaxChars
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoChineseName", $$v)
                            },
                            expression: "job.cargoChineseName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.WoodOrNotWood") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "147",
                                clearable: false,
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_AirExportConstants$WOOD,
                                "default-value": _vm.job.wood,
                                fields: ["chineseName"]
                              },
                              on: { parentCallBack: _vm.onWoodOrNotWoodChagne }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.HazardousGoodsOption")
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "148",
                                clearable: false,
                                filterable: "",
                                "select-type":
                                  _vm.selectTypeNames
                                    .local_cache_AirExportConstants$HAZARDOUS_GOODS_OPTION,
                                "default-value": _vm.job.hazardousGoodsOption,
                                fields: ["chineseName"]
                              },
                              on: {
                                parentCallBack: _vm.onHazardousGoodsOptionChagne
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.handlingInformation")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "149",
                            readonly: true,
                            type: "textarea",
                            rows: 5
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.handlingInformation"),
                                _vm.job.handlingInformation,
                                function(val) {
                                  _vm.job.handlingInformation = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.handlingInformation,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "handlingInformation", $$v)
                            },
                            expression: "job.handlingInformation"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    staticClass: "section form-column",
                    style: _vm.$selectByLang("width:550px;", "width:630px;")
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("booking-air-uld-data-grid", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.airUlds,
                            "is-edit": !_vm.viewStatus,
                            job: _vm.job
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { label: "", "label-width": "120px" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Weight")) +
                                        _vm._s(_vm.openImperial ? "LB" : "KGS")
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.Cubage")) +
                                        _vm._s(_vm.openImperial ? "CFT" : "CBM")
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.ChargedWeight")
                                      ) +
                                        _vm._s(_vm.openImperial ? "LB" : "KGS")
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "font-weight": "normal",
                                      color: "#404144"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.Density")) +
                                        "kg/m³"
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "right",
                                  "min-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      attrs: {
                                        title: _vm.setDimensionsTitle(
                                          _vm.job.commissionDimensions
                                        )
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.Consignation")
                                        ) + " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("auto-number-input", {
                                      attrs: {
                                        no: "18",
                                        precision: 0,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.quantityContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "quantityContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.quantityContract"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "weightContractImperial",
                                        precision: 2,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.weightContractImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightContractImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightContractImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cubAgeContractImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.cubAgeContractImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubAgeContractImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubAgeContractImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "chargeWeightImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.chargeWeightImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.chargeWeightImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "19",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.weightContractChange },
                                      model: {
                                        value: _vm.job.weightContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightContract"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "20",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.cubageContractChange },
                                      model: {
                                        value: _vm.job.cubageContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubageContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubageContract"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "21",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.chargeWeight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "chargeWeight", $$v)
                                        },
                                        expression: "job.chargeWeight"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      attrs: {
                                        precision: 3,
                                        min: 0,
                                        disabled: true,
                                        no: "78"
                                      },
                                      model: {
                                        value: _vm.job.densityContract,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "densityContract",
                                            $$v
                                          )
                                        },
                                        expression: "job.densityContract"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "right",
                                  "min-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      attrs: {
                                        title: _vm.setDimensionsTitle(
                                          _vm.measurements
                                        )
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.Booking")) +
                                          " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("auto-number-input", {
                                      attrs: { no: "22", precision: 0, min: 0 },
                                      model: {
                                        value: _vm.job.quantityBooking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "quantityBooking",
                                            $$v
                                          )
                                        },
                                        expression: "job.quantityBooking"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "weightBookingImperial",
                                        precision: 2,
                                        min: 0
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.weightCubAgeImperialChangeHandler(
                                            "weightBooking"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.weightBookingImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightBookingImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightBookingImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cubAgeBookingImperial",
                                        precision: 3,
                                        min: 0
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.weightCubAgeImperialChangeHandler(
                                            "cubageBooking"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.cubAgeBookingImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubAgeBookingImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubAgeBookingImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "chargeWeightBookingImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value:
                                          _vm.job.chargeWeightBookingImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightBookingImperial",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "job.chargeWeightBookingImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: { no: "23", precision: 3, min: 0 },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.doWeightCubAgeChangeHandler(
                                            "weightBooking"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.weightBooking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightBooking",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightBooking"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: { no: "24", precision: 3, min: 0 },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.doWeightCubAgeChangeHandler(
                                            "cubageBooking"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.cubageBooking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubageBooking",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubageBooking"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "25",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.chargeWeightBooking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightBooking",
                                            $$v
                                          )
                                        },
                                        expression: "job.chargeWeightBooking"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      attrs: { precision: 3, min: 0, no: "79" },
                                      model: {
                                        value: _vm.job.densityBooking,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "densityBooking",
                                            $$v
                                          )
                                        },
                                        expression: "job.densityBooking"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "right",
                                  "min-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      attrs: {
                                        title: _vm.setDimensionsTitle(
                                          _vm.job.dimensionsActual
                                        )
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.FrontCabinActual")
                                        ) + " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("auto-number-input", {
                                      attrs: {
                                        no: "26",
                                        precision: 0,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.quantityActual,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "quantityActual",
                                            $$v
                                          )
                                        },
                                        expression: "job.quantityActual"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "weightActualImperial",
                                        precision: 2,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.weightActualImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightActualImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightActualImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cubAgeActualImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.cubAgeActualImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubAgeActualImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubAgeActualImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cWeightImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.cWeightImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cWeightImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.cWeightImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "27",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.weightActualChange },
                                      model: {
                                        value: _vm.job.weightActual,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "weightActual", $$v)
                                        },
                                        expression: "job.weightActual"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "28",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.cubageActualChange },
                                      model: {
                                        value: _vm.job.cubageActual,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "cubageActual", $$v)
                                        },
                                        expression: "job.cubageActual"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "29",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.weightCubageChangeHandler(
                                            "chargeWeightActual"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.cWeight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "cWeight", $$v)
                                        },
                                        expression: "job.cWeight"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      attrs: {
                                        precision: 3,
                                        min: 0,
                                        disabled: true,
                                        no: "80"
                                      },
                                      model: {
                                        value: _vm.job.densityActual,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "densityActual",
                                            $$v
                                          )
                                        },
                                        expression: "job.densityActual"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "right",
                                  "min-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      attrs: {
                                        title: _vm.setDimensionsTitle(
                                          _vm.job.freightStationDimensions
                                        )
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.FreightStation")
                                        ) + " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("auto-number-input", {
                                      attrs: {
                                        no: "86",
                                        precision: 0,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.quantityStation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "quantityStation",
                                            $$v
                                          )
                                        },
                                        expression: "job.quantityStation"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "weightStationImperial",
                                        precision: 2,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.weightStationImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightStationImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightStationImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cubAgeStationImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.cubAgeStationImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubAgeStationImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubAgeStationImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "chargeWeightStationImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value:
                                          _vm.job.chargeWeightStationImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightStationImperial",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "job.chargeWeightStationImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "87",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.weightStationChange },
                                      model: {
                                        value: _vm.job.weightStation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightStation",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightStation"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "88",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.cubageStationChange },
                                      model: {
                                        value: _vm.job.cubageStation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubageStation",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubageStation"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "89",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.chargeWeightStation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightStation",
                                            $$v
                                          )
                                        },
                                        expression: "job.chargeWeightStation"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      attrs: {
                                        precision: 3,
                                        min: 0,
                                        disabled: true,
                                        no: "90"
                                      },
                                      model: {
                                        value: _vm.job.densityStation,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "densityStation",
                                            $$v
                                          )
                                        },
                                        expression: "job.densityStation"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "right",
                                  "min-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      attrs: {
                                        title: _vm.setDimensionsTitle(
                                          _vm.job.docDimensions
                                        )
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.Documentation")
                                        ) + " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("auto-number-input", {
                                      attrs: { no: "30", precision: 0, min: 0 },
                                      model: {
                                        value: _vm.cargoDoc.quantity,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cargoDoc,
                                            "quantity",
                                            $$v
                                          )
                                        },
                                        expression: "cargoDoc.quantity"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "weightImperial",
                                        precision: 2,
                                        min: 0
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.weightCubAgeImperialChangeHandler(
                                            "weight"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.cargoDoc.weightImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cargoDoc,
                                            "weightImperial",
                                            $$v
                                          )
                                        },
                                        expression: "cargoDoc.weightImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cubAgeImperial",
                                        precision: 3,
                                        min: 0
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.weightCubAgeImperialChangeHandler(
                                            "cubage"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.cargoDoc.cubAgeImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cargoDoc,
                                            "cubAgeImperial",
                                            $$v
                                          )
                                        },
                                        expression: "cargoDoc.cubAgeImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "chargeWeightImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value:
                                          _vm.cargoDoc.chargeWeightImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cargoDoc,
                                            "chargeWeightImperial",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cargoDoc.chargeWeightImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: { no: "31", precision: 3, min: 0 },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.doWeightCubAgeChangeHandler(
                                            "weight"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.cargoDoc.weight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cargoDoc, "weight", $$v)
                                        },
                                        expression: "cargoDoc.weight"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: { no: "32", precision: 3, min: 0 },
                                      on: {
                                        change: function($event) {
                                          return _vm.pm.doWeightCubAgeChangeHandler(
                                            "cubage"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.cargoDoc.cubage,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cargoDoc, "cubage", $$v)
                                        },
                                        expression: "cargoDoc.cubage"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "33",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.cargoDoc.cWeight,
                                        callback: function($$v) {
                                          _vm.$set(_vm.cargoDoc, "cWeight", $$v)
                                        },
                                        expression: "cargoDoc.cWeight"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      attrs: { precision: 3, min: 0, no: "81" },
                                      model: {
                                        value: _vm.job.densityDoc,
                                        callback: function($$v) {
                                          _vm.$set(_vm.job, "densityDoc", $$v)
                                        },
                                        expression: "job.densityDoc"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "right",
                                  "min-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-question",
                                      attrs: {
                                        title: _vm.setDimensionsTitle(
                                          _vm.job.dimensionsSigning
                                        )
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.SignBill")) +
                                          " "
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _c(
                              "el-form-item",
                              {
                                staticClass: "auto-width",
                                attrs: { "label-width": "0px" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("auto-number-input", {
                                      attrs: {
                                        no: "91",
                                        precision: 0,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.quantitySigning,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "quantitySigning",
                                            $$v
                                          )
                                        },
                                        expression: "job.quantitySigning"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "weightSigningImperial",
                                        precision: 2,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.weightSigningChange },
                                      model: {
                                        value: _vm.job.weightSigningImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightSigningImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightSigningImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "cubAgeSigningImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.cubageSigningChange },
                                      model: {
                                        value: _vm.job.cubAgeSigningImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubAgeSigningImperial",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubAgeSigningImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.openImperial,
                                          expression: "openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "chargeWeightSigningImperial",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value:
                                          _vm.job.chargeWeightSigningImperial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightSigningImperial",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "job.chargeWeightSigningImperial"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "92",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.weightSigningChange },
                                      model: {
                                        value: _vm.job.weightSigning,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "weightSigning",
                                            $$v
                                          )
                                        },
                                        expression: "job.weightSigning"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "93",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      on: { change: _vm.cubageSigningChange },
                                      model: {
                                        value: _vm.job.cubageSigning,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "cubageSigning",
                                            $$v
                                          )
                                        },
                                        expression: "job.cubageSigning"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.openImperial,
                                          expression: "!openImperial"
                                        }
                                      ],
                                      attrs: {
                                        no: "94",
                                        precision: 3,
                                        min: 0,
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.job.chargeWeightSigning,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "chargeWeightSigning",
                                            $$v
                                          )
                                        },
                                        expression: "job.chargeWeightSigning"
                                      }
                                    }),
                                    _c("auto-number-input", {
                                      attrs: {
                                        precision: 3,
                                        min: 0,
                                        disabled: true,
                                        no: "95"
                                      },
                                      model: {
                                        value: _vm.job.densitySigning,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "densitySigning",
                                            $$v
                                          )
                                        },
                                        expression: "job.densitySigning"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-right": "5px",
                            "flex-grow": "1"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.Slac"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "slac",
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.slacChangeHandler(p)
                                  }
                                },
                                model: {
                                  value: _vm.job.slac,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "slac", $$v)
                                  },
                                  expression: "job.slac"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.AirlineCompany"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "34",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    airCmp: true,
                                    active: true
                                  },
                                  "default-value": _vm.job.carrierId || "",
                                  disabled: !_vm.carrierIdEnabled,
                                  headers: [
                                    _vm.$t("Tool.ShortName"),
                                    _vm.$t("Partners.chineseName")
                                  ],
                                  fields: ["shortName", "chineseName"],
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.carrierChangeHandler(p.value || 0)
                                    _vm.pm.airlineCompanyChange(p.value || 0)
                                    _vm.airlineCompanyCheckHandler(p.value || 0)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.Flight"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "35" },
                                on: { change: _vm.voyageFlightCheckHandler },
                                model: {
                                  value: _vm.job.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "voyageFlight", $$v)
                                  },
                                  expression: "job.voyageFlight"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.OperationDate"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "36",
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.job.customsDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customsDate", $$v)
                                  },
                                  expression: "job.customsDate"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "120px" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.DateOfDeparture2"))
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-date-picker", {
                                    ref: "etd",
                                    staticStyle: {
                                      flex: "1",
                                      width: "140px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      value: _vm.job.etd,
                                      disabled: _vm.provisionEtdLocked,
                                      no: "37",
                                      clearable: "",
                                      type: "datetime",
                                      "value-format": "yyyy-MM-dd HH:mm",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    on: {
                                      input: _vm.etdChange,
                                      blur: function() {
                                        _vm.handleBlur(
                                          "etd",
                                          _vm.etdChange,
                                          false,
                                          false,
                                          _vm.job
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterWeek")(_vm.job.sailingDay)
                                      )
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm.provisionEtdLocked
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "12px"
                                      }
                                    },
                                    [_vm._v("(已计提校准不可修改)")]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "120px" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.DateOfArrival2"))
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-date-picker", {
                                    ref: "eta",
                                    staticStyle: {
                                      flex: "1",
                                      width: "140px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "38",
                                      type: "datetime",
                                      clearable: "",
                                      "value-format": "yyyy-MM-dd HH:mm",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    on: {
                                      input: _vm.etaChange,
                                      blur: function() {
                                        _vm.handleBlur(
                                          "eta",
                                          _vm.etaChange,
                                          false,
                                          false,
                                          _vm.job
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.job.eta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "eta", $$v)
                                      },
                                      expression: "job.eta"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterWeek")(
                                          _vm.job.etaSailingDay
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "120px" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ActualDateOfDeparture2")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-date-picker", {
                                    ref: "atd",
                                    staticStyle: {
                                      flex: "1",
                                      width: "140px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      value: _vm.job.atd,
                                      no: "39",
                                      disabled: _vm.viewStatus,
                                      type: "datetime",
                                      clearable: "",
                                      "value-format": "yyyy-MM-dd HH:mm",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    on: {
                                      input: _vm.atdChange,
                                      blur: function() {
                                        _vm.handleBlur(
                                          "atd",
                                          _vm.atdChange,
                                          false,
                                          false,
                                          _vm.job
                                        )
                                      }
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterWeek")(
                                          _vm.job.atdSailingDay
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "120px" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ActualDateOfArrival2")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-date-picker", {
                                    ref: "ata",
                                    staticStyle: {
                                      flex: "1",
                                      width: "140px",
                                      "margin-right": "5px"
                                    },
                                    attrs: {
                                      no: "40",
                                      disabled: _vm.viewStatus,
                                      type: "datetime",
                                      clearable: "",
                                      "value-format": "yyyy-MM-dd HH:mm",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    on: {
                                      input: _vm.ataChange,
                                      blur: function() {
                                        _vm.handleBlur(
                                          "ata",
                                          _vm.ataChange,
                                          false,
                                          false,
                                          _vm.job
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.job.ata,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "ata", $$v)
                                      },
                                      expression: "job.ata"
                                    }
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterWeek")(
                                          _vm.job.ataSailingDay
                                        )
                                      )
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.Marks"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("cargo-rich-textarea", {
                                staticStyle: { height: "110px" },
                                attrs: {
                                  no: "41",
                                  disabled: _vm.viewStatus,
                                  "text-chars": 0,
                                  "warning-count": 45,
                                  "auto-uppercase": _vm.isUppercaseByConfig
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Marks"),
                                      _vm.job.mark,
                                      function(val) {
                                        _vm.pm.markChangeHandler(val)
                                      },
                                      true,
                                      null,
                                      _vm.isUppercaseByConfig,
                                      {
                                        warningCount:
                                          _vm.englishNameWarningCount,
                                        maxChar: _vm.englishNameMaxChars
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.mark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "mark", $$v)
                                  },
                                  expression: "job.mark"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.CategoryOfGoods"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "42",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_CargoInformation,
                                  filterable: "",
                                  "callback-params": { key: "cargoCode" },
                                  "default-value": _vm.job.cargoCode,
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack:
                                    _vm.txtCargoInformationChangeHandler
                                }
                              }),
                              _c("el-input", {
                                attrs: { disabled: !_vm.job.cargoCode },
                                model: {
                                  value: _vm.job.cargoName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cargoName", $$v)
                                  },
                                  expression: "job.cargoName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_TransportSource"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_TransportSource,
                                  no: "transportSource",
                                  "default-value": _vm.job.transportSource,
                                  cache: false,
                                  "tag-value": "code",
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.job.transportSource =
                                      item.value)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ServiceStatisticalArea"
                                ),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_StatisticArea,
                                  no: "statisticArea",
                                  "default-value": _vm.job.statisticArea,
                                  cache: false,
                                  "tag-value": "code",
                                  placeholder: " "
                                },
                                on: {
                                  parentCallBack: function(item) {
                                    return (_vm.job.statisticArea = item.value)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "flex-grow": "1" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.MasterBLFreightTerm")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "43",
                                  filterable: "",
                                  clearable: false,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_PaymentTerm,
                                  "default-value": _vm.job.paymentTermMBL || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return _vm.pm.paymentTermMBLChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.BookingProperty")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "44",
                                  filterable: "",
                                  clearable: false,
                                  "select-type":
                                    _vm.selectTypeNames.local_cache_BookingTerm,
                                  "default-value": _vm.job.bookingTerm,
                                  fields: ["chineseName"]
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.bookingTermChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm.isAeBooking
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.PortOfDestinationServices"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { display: "block" },
                                      attrs: { no: "dischargingPortDoor" },
                                      on: {
                                        change: function($event) {
                                          return _vm.syncSlaves(
                                            "dischargingPortDoor"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.dischargingPortDoor,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "dischargingPortDoor",
                                            $$v
                                          )
                                        },
                                        expression: "job.dischargingPortDoor"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.DispatchVehiclesAtDestination"
                                          )
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { display: "block" },
                                      attrs: { no: "usCustomsClearance" },
                                      on: {
                                        change: function($event) {
                                          return _vm.syncSlaves(
                                            "usCustomsClearance"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.job.usCustomsClearance,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "usCustomsClearance",
                                            $$v
                                          )
                                        },
                                        expression: "job.usCustomsClearance"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("queryJob.UsCustomsClearance")
                                        ) + " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { display: "block" },
                                      attrs: { no: "destPortCustomsClearance" },
                                      model: {
                                        value: _vm.job.destPortCustomsClearance,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.job,
                                            "destPortCustomsClearance",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "job.destPortCustomsClearance"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.PortOfDestinationCustomsClearance"
                                          )
                                        ) + " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "45",
                                  filterable: "",
                                  clearable: false,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "callback-method-type": "value",
                                  "default-value": _vm.job.cargoType,
                                  "callback-params": { key: "cargoType" }
                                },
                                on: { parentCallBack: _vm.onCargoTypeChagne }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.OrderChannels")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "82" },
                                model: {
                                  value: _vm.job.salesChannel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "salesChannel", $$v)
                                  },
                                  expression: "job.salesChannel"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.ConsignationRelationNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "trustFromJob" },
                                model: {
                                  value: _vm.job.trustFromJob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "trustFromJob", $$v)
                                  },
                                  expression: "job.trustFromJob"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.BusinessCommissionedRelationNumber"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true, no: "relatedJob" },
                                model: {
                                  value: _vm.job.relatedJob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "relatedJob", $$v)
                                  },
                                  expression: "job.relatedJob"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.showChannelNo
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ChannelNo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: true, no: "83" },
                                    model: {
                                      value: _vm.job.channelNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "channelNo", $$v)
                                      },
                                      expression: "job.channelNo"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Package") } },
                            [
                              _c("cargo-packing-select", {
                                attrs: {
                                  no: "46",
                                  "default-value": _vm.job.packing,
                                  "callback-params": {},
                                  placeholder: " "
                                },
                                on: {
                                  change: function(p) {
                                    p.key = "packing"
                                    _vm.setJobSelectValue(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.CargoSize") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "47",
                                  type: "textarea",
                                  rows: 5,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.measurements,
                                  callback: function($$v) {
                                    _vm.measurements = $$v
                                  },
                                  expression: "measurements"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                            [
                              _c("el-input", {
                                attrs: { no: "48", type: "textarea", rows: 5 },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Remarks"),
                                      _vm.job.remarks,
                                      function(val) {
                                        _vm.job.remarks = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "remarks", $$v)
                                  },
                                  expression: "job.remarks"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "CargoMsg.Cargo_FrontEndWarehouseOperation"
                          )
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "frontEndWarehouseOperation",
                            "select-type":
                              _vm.selectTypeNames
                                .basic_data_AirportCargoTerminal,
                            "method-params": {
                              dataType: 1,
                              deletionFlag: false
                            },
                            filterable: "",
                            clearable: true,
                            "default-value": _vm.job.frontEndWarehouseOperation
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.frontEndWarehouseOperation = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_CargoTerminalOperation")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoTerminalOperation",
                            "select-type":
                              _vm.selectTypeNames
                                .basic_data_AirportCargoTerminal,
                            "method-params": {
                              dataType: 0,
                              deletionFlag: false
                            },
                            filterable: "",
                            clearable: true,
                            "default-value": _vm.job.cargoTerminalOperation
                          },
                          on: {
                            parentCallBack: _vm.cargoTerminalOperationChange
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_EstimatedDeliveryDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "200px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            disabled:
                              !_vm.isEdit || !_vm.job.cargoTerminalOperation,
                            no: "estimatedDeliveryDate",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.job.estimatedDeliveryDate,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "estimatedDeliveryDate", $$v)
                            },
                            expression: "job.estimatedDeliveryDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.CustomerReferenceNumber")
                        }
                      },
                      [
                        _c("cargo-input", {
                          attrs: { no: "76", trim: true },
                          model: {
                            value: _vm.job.customerRefNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customerRefNo", $$v)
                            },
                            expression: "job.customerRefNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "50",
                            filterable: "",
                            clearable: false,
                            "select-type":
                              _vm.selectTypeNames.basic_data_TradeTerm,
                            "callback-method-type": "value",
                            "default-value": _vm.job.tradeTerm,
                            "callback-params": { key: "tradeTerm" }
                          },
                          on: { parentCallBack: _vm.setJobSelectValue }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "dcOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.dcOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcOffice = p.value
                              _vm.job.dcDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Message.Documentation_Department"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "dcDepartment",
                            "office-id": Number(_vm.job.dcOffice),
                            enables: true,
                            "department-id": Number(_vm.job.dcDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Documents") } },
                      [
                        _c("cargo-user-select", {
                          ref: "dc",
                          attrs: {
                            no: "51",
                            "method-params": { category: "role", shape: "doc" },
                            "default-value": _vm.job.dc || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.doc
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.dcChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "plannerOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.plannerOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerOffice = p.value
                              _vm.job.plannerDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.AirlineDepartment"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "plannerDepartment",
                            "office-id": Number(_vm.job.plannerOffice),
                            enables: true,
                            "department-id": Number(_vm.job.plannerDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "52",
                            "method-params": {
                              officeId: _vm.job.opOffice,
                              category: "role",
                              shape: "airline"
                            },
                            "default-value": _vm.job.planner || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.airline
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.plannerChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "53",
                            "method-params": {
                              officeId: _vm.job.opOffice,
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.siteOp
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "54",
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || "",
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.cargoSalesId = p.value
                              _vm.pm.cargoSalesChargeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                      [
                        _c("el-input", {
                          attrs: { no: "55", disabled: true },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.SalesDepartment") } },
                      [
                        _c("cargo-department-new-select", {
                          attrs: {
                            no: "56",
                            disabled: !_vm.job.sales,
                            enables: true,
                            "sales-id": Number(_vm.job.sales),
                            "office-id": _vm.job.salesOffice,
                            "department-id": Number(_vm.job.salesDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.salesDepartmentChargeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Sales") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              ref: "sales",
                              staticStyle: { width: "130px", flex: "1" },
                              attrs: {
                                no: "57",
                                disabled: !_vm.saleEnabled,
                                "method-params": {
                                  officeId: _vm.pm.salesOfficeCheck
                                    ? _vm.$store.getters.currentOfficeId
                                    : "",
                                  category: "role",
                                  shape: "sales",
                                  active: true
                                },
                                "default-value": _vm.job.sales || "",
                                "static-options": _vm.salesList,
                                placeholder: _vm.salesPrompt || " "
                              },
                              on: {
                                change: function(p) {
                                  _vm.pm.salesChangeHandler(p)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "58",
                            disabled: _vm.opOfficeDisabled,
                            "office-id": Number(_vm.job.opOffice),
                            placeholder: " ",
                            "is-regional-commission": _vm.isRegionalCommission
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.opOfficeChargeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                            )
                          ]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "59",
                            "office-id": Number(_vm.job.opOffice),
                            enables: true,
                            "department-id": Number(_vm.job.opDepartment),
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.Operation") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "60",
                            "method-params": {
                              officeId: _vm.job.opOffice,
                              category: "role",
                              shape: "op"
                            },
                            "default-value": _vm.job.op || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.op
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.opChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                      [
                        _c("cargo-office-select", {
                          attrs: {
                            no: "csrOffice",
                            disabled: true,
                            "office-id": Number(_vm.job.csrOffice)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrOffice = p.value
                              _vm.job.csrDepartment = 0
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("Message.Customer_Service")))]
                        ),
                        _c("cargo-department-select", {
                          attrs: {
                            no: "csrDepartment",
                            "office-id": Number(_vm.job.csrOffice),
                            enables: true,
                            "department-id": Number(_vm.job.csrDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                      [
                        _c("cargo-user-select", {
                          attrs: {
                            no: "61",
                            "method-params": { category: "role", shape: "csr" },
                            "default-value": _vm.job.csr || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.csr
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.csrChangeHandler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAddUserDefinedRoles,
                            expression: "isAddUserDefinedRoles"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "userDefinedRoleId1",
                          attrs: {
                            no: "userDefinedRoleId1",
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole1"
                            },
                            "default-value": _vm.job.userDefinedRoleId1 || "",
                            "merge-load": true,
                            placeholder: " ",
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole1
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.userDefinedRoleId1Handler(p)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isAddUserDefinedRoles,
                            expression: "isAddUserDefinedRoles"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "userDefinedRoleId2",
                          attrs: {
                            no: "userDefinedRoleId2",
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole2"
                            },
                            "default-value": _vm.job.userDefinedRoleId2 || "",
                            "merge-load": true,
                            placeholder: " ",
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole2
                          },
                          on: {
                            change: function(p) {
                              _vm.pm.userDefinedRoleId2Handler(p)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.isFba
                  ? _c(
                      "div",
                      { staticClass: "section form-column" },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              disabled: _vm.viewStatus,
                              "label-width": "120px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("AirExport.ServiceChannel")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { no: "serviceChannel" },
                                  model: {
                                    value: _vm.fbaJob.serviceChannel,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "serviceChannel",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.serviceChannel"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "blue",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "AirExport.EstimatedStorageGoodArrivalTime"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "preWarehousingTime",
                                    type: "datetime",
                                    clearable: "",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.fbaJob.preWarehousingTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.fbaJob,
                                        "preWarehousingTime",
                                        $$v
                                      )
                                    },
                                    expression: "fbaJob.preWarehousingTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("el-form-item", [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Destination"))
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex", flex: "1" } },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.fbaJob.warehouseCode,
                                        placement: "bottom-end"
                                      }
                                    },
                                    [
                                      _c("el-cascader", {
                                        staticStyle: { "padding-right": "2px" },
                                        attrs: {
                                          options: _vm.destinations,
                                          filterable: "",
                                          clearable: true,
                                          no: "84"
                                        },
                                        on: {
                                          focus: function($event) {
                                            return _vm.JobUtils.focusWarehouseCode(
                                              _vm.fbaJob
                                            )
                                          },
                                          blur: function($event) {
                                            return _vm.JobUtils.blurWarehouseCode(
                                              _vm.fbaJob
                                            )
                                          },
                                          change: function(p) {
                                            _vm.JobUtils.warehouseCodeHandler(
                                              _vm.fbaJob,
                                              p
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.fbaJob.warehouseCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fbaJob,
                                              "warehouseCode",
                                              $$v
                                            )
                                          },
                                          expression: "fbaJob.warehouseCode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { no: "remoteWarehouse" },
                                      model: {
                                        value: _vm.fbaJob.remoteWarehouse,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.fbaJob,
                                            "remoteWarehouse",
                                            $$v
                                          )
                                        },
                                        expression: "fbaJob.remoteWarehouse"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("AirExport.RemoteWarehouse")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("Warehouse.DestinationCountry")
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { disabled: true, no: "country" },
                                  model: {
                                    value: _vm.fbaJob.country,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fbaJob, "country", $$v)
                                    },
                                    expression: "fbaJob.country"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              { attrs: { label: _vm.$t("AirExport.ZipCode") } },
                              [
                                _c("el-input", {
                                  attrs: { disabled: true, no: "zipCode" },
                                  model: {
                                    value: _vm.fbaJob.zipCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fbaJob, "zipCode", $$v)
                                    },
                                    expression: "fbaJob.zipCode"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "AirExport.DestinationDeliveryMethod"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "destinationDistribution",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                    filterable: "",
                                    clearable: false,
                                    "default-value":
                                      _vm.fbaJob.destinationDistribution
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.fbaJob.destinationDistribution =
                                        p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm.fbaJob.destinationDistribution &&
                            Number(_vm.fbaJob.destinationDistribution) === 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("AirExport.CourierCompany")
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          no: "expressCompany",
                                          placeholder: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.fbaJob.expressCompany,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.fbaJob,
                                              "expressCompany",
                                              $$v
                                            )
                                          },
                                          expression: "fbaJob.expressCompany"
                                        }
                                      },
                                      _vm._l(
                                        _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.chineseName,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.fbaJob.destinationDistribution &&
                            Number(_vm.fbaJob.destinationDistribution) === 1
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("AirExport.CourierNumber")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { no: "expressNo" },
                                      model: {
                                        value: _vm.fbaJob.expressNo,
                                        callback: function($$v) {
                                          _vm.$set(_vm.fbaJob, "expressNo", $$v)
                                        },
                                        expression: "fbaJob.expressNo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("AirExport.DomesticWarehouse")
                                }
                              },
                              [
                                _c("cargo-company-select", {
                                  attrs: {
                                    no: "warehouseCmp",
                                    "method-params": {
                                      warehouse: true,
                                      active: true
                                    },
                                    "default-value":
                                      Number(_vm.fbaJob.domesticWarehouse) ||
                                      "",
                                    placeholder: _vm.$t(
                                      "SeaExport.PleaseSelectWarehouse"
                                    )
                                  },
                                  on: {
                                    change: function(p) {
                                      _vm.fbaJob.domesticWarehouse = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("AirExport.ForeignWarehouse")
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "overseaWarehouseCode",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_OverseaWarehouse,
                                    filterable: "",
                                    "method-params": { ifFba: false },
                                    clearable: false,
                                    "tag-name": "countryChineseName",
                                    "tag-value": "warehouseCode",
                                    "default-value":
                                      _vm.job.overseaWarehouseCode
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.job.overseaWarehouseCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "AirExport.CustomsDeclarationMethod"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "customsMethodPol",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_CustomsMode,
                                    "method-params": { serviceType: 0 },
                                    filterable: "",
                                    clearable: false,
                                    "default-value": _vm.fbaJob.customsMethodPol
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.fbaJob.customsMethodPol = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "SeaExport.CustomsDeclarationType"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "customsDeclarationType",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_CustomsDeclarationType,
                                    filterable: "",
                                    "default-value":
                                      _vm.job.customsDeclarationType || "",
                                    placeholder: _vm.$t(
                                      "CargoMsg.Cargo_keyWordsTip"
                                    )
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.job.customsDeclarationType = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "AirExport.CustomsClearanceMethod"
                                  )
                                }
                              },
                              [
                                _c("cargo-advance-select", {
                                  attrs: {
                                    no: "customsMethodPod",
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_CustomsMode,
                                    "method-params": { serviceType: 1 },
                                    filterable: "",
                                    clearable: false,
                                    "default-value": _vm.fbaJob.customsMethodPod
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.fbaJob.customsMethodPod = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c("hr", {
                              staticStyle: {
                                "margin-top": "20px",
                                "margin-bottom": "20px"
                              }
                            }),
                            _c("span", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.PODDeliveryInformation")
                                )
                              )
                            ]),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "SeaExport.DeliveryToWarehouseMessage"
                                  ),
                                  label: _vm.$t(
                                    "SeaExport.EstimatedDeliveryToWarehouseTime"
                                  )
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "estWarehouseDeliveryTime",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.job.estWarehouseDeliveryTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.job,
                                        "estWarehouseDeliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "job.estWarehouseDeliveryTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "SeaExport.DeliveryToWarehouseMessage"
                                  ),
                                  label: _vm.$t(
                                    "SeaExport.ActualDeliveryToWarehouseTime"
                                  )
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "actWarehouseDeliveryTime",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.job.actWarehouseDeliveryTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.job,
                                        "actWarehouseDeliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "job.actWarehouseDeliveryTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                                  ),
                                  label: _vm.$t(
                                    "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                                  )
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "estGoodsDeliveryTime",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.job.estGoodsDeliveryTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.job,
                                        "estGoodsDeliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "job.estGoodsDeliveryTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                                  ),
                                  label: _vm.$t(
                                    "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                                  )
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "actGoodsDeliveryTime",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.job.actGoodsDeliveryTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.job,
                                        "actGoodsDeliveryTime",
                                        $$v
                                      )
                                    },
                                    expression: "job.actGoodsDeliveryTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "AirExport.EstimatedDeliveryTime"
                                  )
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "estDeliveryTime",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.job.estDeliveryTime,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "estDeliveryTime", $$v)
                                    },
                                    expression: "job.estDeliveryTime"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("AirExport.ActualDeliveryTime")
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    no: "actDeliveryTime",
                                    type: "datetime",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    format: "yyyy-MM-dd HH:mm"
                                  },
                                  model: {
                                    value: _vm.job.actDeliveryTime,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "actDeliveryTime", $$v)
                                    },
                                    expression: "job.actDeliveryTime"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "section form-column" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField1") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "62", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField1"),
                                _vm.job.userDefinedField1,
                                function(val) {
                                  _vm.job.userDefinedField1 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField1,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField1", $$v)
                            },
                            expression: "job.userDefinedField1"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField2") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "63", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField2"),
                                _vm.job.userDefinedField2,
                                function(val) {
                                  _vm.job.userDefinedField2 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField2,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField2", $$v)
                            },
                            expression: "job.userDefinedField2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField3") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "64", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField3"),
                                _vm.job.userDefinedField3,
                                function(val) {
                                  _vm.job.userDefinedField3 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField3,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField3", $$v)
                            },
                            expression: "job.userDefinedField3"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.UserDefinedField4") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "65", type: "textarea", rows: 5 },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.UserDefinedField4"),
                                _vm.job.userDefinedField4,
                                function(val) {
                                  _vm.job.userDefinedField4 = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.userDefinedField4,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "userDefinedField4", $$v)
                            },
                            expression: "job.userDefinedField4"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              no: "taxNature",
                              placeholder: _vm.$t("SeaExport.PleaseSelect"),
                              size: "mini"
                            },
                            model: {
                              value: _vm.job.taxNature,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "taxNature", $$v)
                              },
                              expression: "job.taxNature"
                            }
                          },
                          _vm._l(_vm.TAX_NATURES, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: _vm.isZh
                                  ? item.chineseName
                                  : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c("div", { staticClass: "section" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("SeaExport.TicketsInfo")))
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "margin-bottom": "5px",
                  "line-height": "28px"
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                ]),
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v(
                    _vm._s(_vm.job.lclSlaves ? _vm.job.lclSlaves.length : 0)
                  )
                ]),
                _vm.viewStatus && _vm.viewSource === "bookingWorkspace"
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cooperateEdit,
                            expression: "cooperateEdit"
                          }
                        ],
                        staticClass: "triggers"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { no: "66", type: "primary" },
                            on: { click: _vm.newSubJobHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "67",
                              type: "primary",
                              disabled: !_vm.selectedRow
                            },
                            on: { click: _vm.editSubJobHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "68",
                              type: "primary",
                              disabled: Number(_vm.job.operateType) !== 0
                            },
                            on: { click: _vm.attachSubJobHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "69",
                              type: "danger",
                              disabled:
                                !_vm.selectedRow ||
                                _vm.viewSource === "financeDetail"
                            },
                            on: { click: _vm.detachSubJobHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "min-height": "200px",
                  "flex-direction": "column"
                }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { height: "350px" },
                  attrs: {
                    "config-module": "150006",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c("transit-port-dialog", {
        attrs: { visible: _vm.transitPortDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transitPortDialog, "visible", $event)
          },
          enter: _vm.transitPortEnterHandler
        }
      }),
      _c("select-mawb-dialog", {
        attrs: {
          visible: _vm.selectMawbDialog.visible,
          "carrier-id": _vm.selectMawbDialog.carrierId,
          type: _vm.selectMawbDialog.type,
          "operate-type": _vm.selectMawbDialog.operateType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectMawbDialog, "visible", $event)
          },
          enterEvent: _vm.selectedMAWBHandler
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "70",
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            },
            close: _vm.closeAdvanceText
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.showDialog,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              no: "85"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.viewStatus,
                      expression: "!viewStatus"
                    }
                  ],
                  attrs: { no: "71", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "71_1" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                      _vm.closeAdvanceText()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            no: "72",
            visible: _vm.ticketDialog.visible,
            title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
            width: "270px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.ticketDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "50px", "label-position": "right" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      no: "73",
                      precision: 0,
                      min: 1,
                      max: 50,
                      controls: false
                    },
                    model: {
                      value: _vm.ticketDialog.value,
                      callback: function($$v) {
                        _vm.$set(_vm.ticketDialog, "value", $$v)
                      },
                      expression: "ticketDialog.value"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "74", type: "primary" },
                  on: { click: _vm.toAddTicket }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "75", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ticketDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("query-ae-lcl-dialog", {
        attrs: { visible: _vm.queryAeLclDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryAeLclDialog, "visible", $event)
          },
          attachSubJobCallBackHandler: _vm.attachSubJobCallBackHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }